import React from 'react';
import LaunchSites from '../../../partials/LaunchSites'

const Results = (props) => {
  const { subjects, locations, onChoosedLocation } = props;

  return (
    <div className="Results">
      <LaunchSites rocketrep={ subjects } locations={locations} onChoosedLocation={onChoosedLocation} />
    </div>
  );
}
export default Results;
